module.exports = __webpack_public_path__ + "media/ru_ru_s2_Katja.9e02f844.mp3";